import React from "react";

function IconInfo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 20">
      <circle cx="7" cy="10" r="7" />
      <path
        fill="#fff"
        d="M7 7.179c.483 0 .88-.387.88-.87A.877.877 0 007 5.433a.881.881 0 00-.886.876c0 .483.403.87.886.87zM6.216 14h1.563V8.086H6.216V14z"
      />
    </svg>
  );
}

export default IconInfo;
